import React from 'react';
import Route from '@src/route'

function App() {
	return <Route/>;
}

export default App;
